module.exports = __webpack_public_path__ + "img/1557614108852953090.711742da.png";